var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabelArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2043 0.179491C15.4451 0.419415 15.4458 0.809102 15.2058 1.04988L8.47887 7.80086C8.21429 8.06638 7.78432 8.06638 7.51974 7.80086L0.792771 1.04988C0.552847 0.809102 0.553542 0.419414 0.794321 0.17949C1.0351 -0.0604341 1.42479 -0.05974 1.66471 0.18104L7.99931 6.53824L14.3339 0.181041C14.5738 -0.0597394 14.9635 -0.0604335 15.2043 0.179491Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelArrow);
export default __webpack_public_path__ + "static/media/label-arrow.352b8ccd84f0f82ac914770eb27ad058.svg";
export { ForwardRef as ReactComponent };